import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'
import modules from './modules-list'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const persistedState = createPersistedState({ paths: ['common.isChatOpen'] })

const Store = new Vuex.Store({
  modules,
  strict: debug,
  plugins: debug ? [createLogger(), persistedState] : [persistedState],
})

export default Store
window.$store = Store

export function useStore() {
  return Store
}
